import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import type { Uuid } from '@/data/db';
import { ReminderFollowUpPanel } from '@/features/reminders/reminder-follow-up-panel';

interface FollowUpContextValue {
  /** 標示已提醒之後呼叫，跳出「這件事結案了嗎」。 */
  askFollowUp: (reminderId: Uuid) => void;
}

const FollowUpContext = createContext<FollowUpContextValue | null>(null);

/** 全域的後續處理面板 host，讓今日桌面與詳細抽屜共用同一個面板。 */
export function FollowUpProvider({ children }: { children: ReactNode }) {
  const [reminderId, setReminderId] = useState<Uuid | null>(null);

  const askFollowUp = useCallback((id: Uuid) => setReminderId(id), []);
  const value = useMemo<FollowUpContextValue>(() => ({ askFollowUp }), [askFollowUp]);

  return (
    <FollowUpContext value={value}>
      {children}
      {reminderId && (
        <ReminderFollowUpPanel
          reminderId={reminderId}
          open
          onOpenChange={(open) => {
            if (!open) setReminderId(null);
          }}
        />
      )}
    </FollowUpContext>
  );
}

export function useOptionalFollowUp(): FollowUpContextValue | null {
  return useContext(FollowUpContext);
}
